// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609010634/js/" + chunkId + "." + {"44":"6c8afe74","225":"77fc0fe3","481":"625351ad","486":"3208bfa2","770":"8a59d6f1"}[chunkId] + ".0.008685286230027622.chunk.js";
};